import React, { useEffect } from 'react';
import { useAppType } from '../../hooks/useAppType';
import { Platform } from 'react-native';
import { AnimateLoadedContent } from '../v2BaseComponents/Loader';
import { initialNavigationUrl } from '../../utils/initialNavigationUrl';

export type ReconcileProConsumerNavigationOwnProps = {
    renderContent: () => React.ReactNode;
};

export type ReconcileProConsumerNavigationProps = ReconcileProConsumerNavigationOwnProps;

const appTypeRoutes = {
    proClientsBase: '/app/clients/',
    consumerProfilesBase: '/app/profiles/',
};

/**
 * There are inconsistencies between the consumer and professional navigation.  If navigating to a consumer route app in the professional app (or vice-versa), we need to reconcile the navigation.
 */
const ReconcileProConsumerNavigation: React.FC<ReconcileProConsumerNavigationProps> = (props) => {
    const appType = useAppType();
    const [isRouteValidated, setIsRouteValidated] = React.useState(false);
    useEffect(() => {
        if (Platform.OS !== 'web') {
            setIsRouteValidated(true);
            return;
        }

        const expectedPathPart =
            appType === 'professional' ? appTypeRoutes.proClientsBase : appTypeRoutes.consumerProfilesBase;
        const conflictingPathPart =
            appType === 'professional' ? appTypeRoutes.consumerProfilesBase : appTypeRoutes.proClientsBase;

        if (initialNavigationUrl.includes(conflictingPathPart)) {
            const newPath = initialNavigationUrl.replace(conflictingPathPart, expectedPathPart);
            window.location.href = newPath;
        } else {
            setIsRouteValidated(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return <AnimateLoadedContent isLoading={!isRouteValidated}>{props.renderContent}</AnimateLoadedContent>;
};

export default React.memo(ReconcileProConsumerNavigation);
